module.exports = __webpack_public_path__ + "static/media/cq_contrassegna_elemento1.671063ff.svg";